import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import type { RefObject } from 'react';
import { useGetBuddyPreferenceByUserProfileId } from '../../../domains/findBuddy/ui/hooks/useGetBuddyPreferenceByUserProfileId';
import FanBuddyProfileCard from '../../fanBuddy/components/FanBuddyProfileCard';

interface SocialProfileSectionProps {
  userProfileId: string;
  isMine: boolean;
  followingsCount: number;
  followersCount: number;
  handleClickCard: () => void;
  handleOpenCard?: () => void;
  styleAnchorRef?: RefObject<HTMLDivElement>;
  onCardLayoutReady?: () => void;
}

const SocialProfileSection = ({
  userProfileId,
  isMine,
  followingsCount,
  followersCount,
  handleClickCard,
  handleOpenCard,
  styleAnchorRef,
  onCardLayoutReady
}: SocialProfileSectionProps) => {
  const navigate = useNavigate();
  const { data: buddyPreference } = useGetBuddyPreferenceByUserProfileId(userProfileId);

  useEffect(() => {
    if (buddyPreference) {
      onCardLayoutReady?.();
    }
  }, [buddyPreference, onCardLayoutReady]);

  if (!buddyPreference) {
    return null;
  }

  return (
    <div className="flex flex-row items-start justify-between px-[24px] pb-[30px]">
      <div className="flex flex-col gap-[26px] text-[13px] text-text-main-lv2 mt-[51px] leading-[16px]">
        <button
          type="button"
          onClick={() => navigate(`/feed/user_profile/${userProfileId}/followings`)}
          className="flex flex-col items-start gap-[4px] font-semibold"
        >
          Following
          <p className="text-[15px] leading-[18px]">{followingsCount}</p>
        </button>
        <button
          type="button"
          onClick={() => navigate(`/feed/user_profile/${userProfileId}/followers`)}
          className="flex flex-col items-start gap-[4px] font-semibold"
        >
          Follower
          <p className="text-[15px] leading-[18px]">{followersCount}</p>
        </button>
      </div>
      <FanBuddyProfileCard
        size="small"
        isMine={isMine}
        buddyProfileCard={buddyPreference}
        onCardClick={handleClickCard}
        onRequestOpenCard={handleOpenCard}
        redirectPath={`/feed/user_profile/${userProfileId}`}
        styleAnchorRef={styleAnchorRef}
      />
    </div>
  );
};

export default SocialProfileSection;
